import { cloudStorage } from "@/utils/storage";
import { isString } from "lodash";
import { localCacheKeyMap } from "./constant";
import { LocalCacheType } from "./types/local";
import { DEFAULT_PROJECT_CONFIG, localCacheValueFormatter, localCacheValueGetter } from "./utils";
import {
  Logger,
  shallowCopy,
  Graph,
  isUndefined,
  Matrix2D,
  Matrix2DFields,
  identityMatrix2DFields,
} from "@noli/core";
import { BoardStore, useIsReady } from "@noli/business";
import { ValueOf } from "@/types/base";
import { loginStore } from "../login/store";

export class LocalCacheManager {
  get data(): LocalCacheType {
    return this.getLocalCache();
  }

  get id() {
    // let id = cloudStorage.get(localCacheKeyMap.id);
    // if (!id) {
    //   id = DEFAULT_PROJECT_CONFIG.projectId();
    //   cloudStorage.save(localCacheKeyMap.id, id);
    // }
    return this.getLocalCache().id;
  }

  get updateTime() {
    // let updateTime = cloudStorage.get(localCacheKeyMap.updateTime);
    // if (!updateTime) {
    //   updateTime = Date.now().toString();
    //   cloudStorage.save(localCacheKeyMap.updateTime, updateTime);
    // }
    // return parseInt(updateTime);
    return this.getLocalCache().updateTime;
  }

  get name() {
    // let name = cloudStorage.get(localCacheKeyMap.name);
    // if (!name) {
    //   name = DEFAULT_PROJECT_CONFIG.projectName();
    //   cloudStorage.save(localCacheKeyMap.name, name);
    // }
    // return name;
    return this.getLocalCache().name;
  }

  setName(name: string) {
    cloudStorage.save(localCacheKeyMap.name, name);
  }

  get preview() {
    // return cloudStorage.get(localCacheKeyMap.preview);
    return this.getLocalCache().preview ?? "";
  }

  get graph() {
    // const graphJsonString = cloudStorage.get(localCacheKeyMap.graph);
    // if (!graphJsonString) return new Graph();
    // return Graph.fromJson(graphJsonString).clean().graph;
    return this.getLocalCache().graph;
  }

  get globalTransform() {
    // const transformJsonString = cloudStorage.get(localCacheKeyMap.globalTransform);
    // if (!transformJsonString) return identityMatrix2DFields;
    // return Matrix2D.fromJson(transformJsonString);
    return this.getLocalCache().globalTransform;
  }

  get commitId() {
    // return cloudStorage.get(localCacheKeyMap.commit_id) ?? undefined;
    return this.getLocalCache().commit_id;
  }

  setCommitId(newCommitId: string) {
    cloudStorage.save(localCacheKeyMap.commit_id, newCommitId);
  }

  isSameUser() {
    if (!loginStore.userInfo.userId) return false;
    return this.localUserId !== loginStore.userInfo.userId;
  }

  private getLocalCache() {
    const storageValues = cloudStorage.getItems(Object.values(localCacheKeyMap));
    console.log("getLocalCache storageValues: ", storageValues);

    const localCache: LocalCacheType = {
      id: localCacheValueGetter.id(storageValues?.[localCacheKeyMap.id]),
      name: localCacheValueGetter.name(storageValues?.[localCacheKeyMap.name]),
      graph: localCacheValueGetter.graph(storageValues?.[localCacheKeyMap.graph]),
      globalTransform: localCacheValueGetter.globalTransform(
        storageValues?.[localCacheKeyMap.globalTransform],
      ),
      updateTime: localCacheValueGetter.updateTime(storageValues?.[localCacheKeyMap.updateTime]),
      userId: localCacheValueGetter.userId(storageValues?.[localCacheKeyMap.userId]),
      commit_id: localCacheValueGetter.commit_id(storageValues?.[localCacheKeyMap.commit_id]),
    };
    return localCache;
  }

  get localUserId(): number | undefined {
    return this.getLocalCache().userId;
  }

  setData(data: Partial<LocalCacheType>) {
    (Object.keys(data) as (keyof LocalCacheType)[]).forEach((key) => {
      const value = data[key] as ValueOf<LocalCacheType>;
      if (localCacheValueFormatter[key]) {
        const formattedValue = localCacheValueFormatter[key](value);
        if (typeof formattedValue === "string") {
          cloudStorage.save(localCacheKeyMap[key], formattedValue);
        }
      }
    });
  }

  setDataFromBoard(userId?: number) {
    const isReady = useIsReady();
    if (isReady && this.id && this.name) {
      const { id, name, userId: localUserId, commit_id } = this.data;
      Logger.debug("Saving Cache");
      this.setData({
        commit_id,
        id,
        name,
        graph: BoardStore.graph,
        globalTransform: BoardStore.board.globalTransform,
        updateTime: new Date().getTime(),
        userId: userId ?? localUserId,
      });
    }
  }
}

export const localCacheManager = new LocalCacheManager();
